<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="stock-product">
                    <icon name="warehouse"></icon>
                    สต็อคสินค้า
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "stock-product-layout"
    }
</script>

<style scoped>

</style>